import { render, staticRenderFns } from "./tomcat-project-file.vue?vue&type=template&id=70f82662&scoped=true&"
import script from "./tomcat-project-file.vue?vue&type=script&lang=js&"
export * from "./tomcat-project-file.vue?vue&type=script&lang=js&"
import style0 from "./tomcat-project-file.vue?vue&type=style&index=0&id=70f82662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f82662",
  null
  
)

export default component.exports